import React, { useState } from 'react';
import Image from 'next/image';
import styles from '../turmeric/Turmeric.module.scss';
import DownArrow from '../../../src/images/down.svg';
import {
  addItemToCart,
  updateFreeGift,
} from '../../../src/features/cart/cartState';
import { useAppDispatch } from '../../../src/app/hooks';
import Router from 'next/router';
import { FBAddToCart } from '../../../commons/helpers/Analytics/fbPixel';
import { GASelectedItem } from '../../../commons/helpers/Analytics/googleAnalytics';
import { getProducts } from '../../../commons/utils/productsHelper';
import { useAppSelector } from '../../../src/app/hooks';
import Supplement from './supplement';
import Arrow from '../../../src/images/down-arrow-svg.svg';
import { productsKeyConstants } from '../../../config';
import { ORDER_PHONENO } from '../../../commons/Constants';
import imgLoader from '../../../imgloader';
import {
  quickstartImage,
  productImages,
  turmericBowlImage,
} from '../../../src/images';

function TurmericPage() {
  const dispatch = useAppDispatch();
  const products = getProducts();
  const rfOfferPrice = products[productsKeyConstants.RF_RELIEF_FACTOR_QS_NEC];
  const tag = productsKeyConstants.RF_RELIEF_FACTOR_QS_NEC;
  const quantity = '1';
  const category = 'REL';
  const customerId = '';
  const [open, setOpen] = useState(false);
  const handleOpenClose = () => {
    setOpen(!open);
  };
  const updateCart = () => {
    FBAddToCart(products[productsKeyConstants.RF_RELIEF_FACTOR_QS_NEC], false);
    GASelectedItem(
      customerId,
      products[productsKeyConstants.RF_RELIEF_FACTOR_QS_NEC]
    );
    const payload = {
      productId:
        products[productsKeyConstants.RF_RELIEF_FACTOR_QS_NEC]?.quoteParams
          ?.productId,
      data: {
        key: tag,
        quantity: quantity,
        isSubscription: true,
        category: category,
      },
      customerId,
    };
    dispatch(addItemToCart(payload));
  };

  const handleSubmit = () => {
    updateCart();
    // dispatch(
    //   updateFreeGift({
    //     parentProductId: 115,
    //     triggerType: 2,
    //   })
    // );
    // Router.push('/freegift', undefined, { shallow: true });
  };

  const handleScrollView = () => {
    var element = document.getElementById('bottomSection');
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'start',
    });
  };
  function onClickHandler() {
    return;
  }

  return (
    <div className={styles.turmericPageContainer}>
      <div className={styles.topContainer}>
        <div className={styles.topSection}>
          <h1 className={styles.header}>
            Relief Factor Ingredients:
            <br />
            <span className={styles.subheader1}> Turmeric</span>
          </h1>
          <div className={styles.turmericDetails}>
            <div className={styles.firstparagraph}>
              <p className={styles.paragraph}>
                Turmeric is a root — in the ginger family — used in many
                cuisines, from South Asian soups, curries and sweets, to Thai
                yellow curry, to American deli mustard. A staple of traditional
                South Asian and Chinese medicines for centuries,
                <b>Turmeric provides Curcumin</b>, a phytosome for enhanced
                absorption and bioavailability.
              </p>
              <p className={styles.paragraph} style={{ marginTop: '15px' }}>
                {' '}
                Curcumin offers maximal support for the body’s{' '}
                <b>natural and healthy response</b> to overexertion that can
                cause minor, but temporary discomfort. Curcumin supports the
                balanced activities of multiple enzyme systems. With all the
                potential benefits from Curcumin, Turmeric is a very{' '}
                <b>healthy addition to your diet</b>, and a core ingredient in
                the physician-developed formula of Relief Factor.
              </p>
            </div>
            <div className={styles.turmericImage}>
              <Image
                alt="Turmeric"
                src={productImages.turmericImageStr}
                loading="eager"
                loader={imgLoader}
                width={500}
                height={265}
              />
              <div className={styles.getRelief}>
                <button onClick={handleScrollView}>
                  <span className={styles.rightArrow}>
                    <DownArrow />
                  </span>
                  <span className={styles.orderNowText}>GET RELIEF</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.greenbar}>
        <div className={styles.greenbarArrow}>
          <Arrow color="#004152" />
        </div>
      </div>
      <div className={styles.secondContainer}>
        <div className={styles.aboutTurmeric}>
          <h2 className={styles.header1}>
            Join tens of thousands
            <br />
            of people before you...
          </h2>
          <p className={styles.paragraph1}>
            Relief Factor is a 100% drug-free, botanical and fish oil product,
            born out of 15 years of clinical practice, crafted to help your body
            reduce pain associated with aging, exercise, and everyday living.
          </p>
          <p className={styles.paragraph1}>
            The combination of ingredients (
            <a onClick={handleOpenClose}>Curcumin</a>,{' '}
            <a onClick={handleOpenClose}>Resveratrol</a>,{' '}
            <a onClick={handleOpenClose}>Icariin</a>, and{' '}
            <a onClick={handleOpenClose}>Omega-3</a>) helps support the body's
            natural response to inflammation…to <b>lower or even eliminate </b>
            pain associated with exercise and everyday living. Relief Factor
            targets the underlying problem areas from four different metabolic
            pathways to
            <b> alleviate pain at the source.</b>
          </p>
          <ul className={styles.ultag}>
            <li className={styles.list1}> 100% drug-free*</li>
            <li className={styles.list1}>
              100% botanical and fish oil product, made from a
              clinically-developed formula that supports regulation of key
              enzymes and proteins*
            </li>
            <li className={styles.list1}>
              Supports a healthy response to inflammation and decreases
              discomfort*
            </li>
            <li className={styles.list1}>Convenient individual packets*</li>
            <li className={styles.list1}>
              Supports healthy joints and muscles*
            </li>
          </ul>
        </div>
        <div className={styles.turmericImageTwo}>
          <Image
            alt="Turmeric"
            src={turmericBowlImage}
            loading="eager"
            loader={imgLoader}
            width={403}
            height={500}
          />
        </div>
      </div>
      <div id="bottomSection" className={styles.thirdContainer}>
        <div className={styles.productDetails}>
          <h2 className={styles.header2}>
            Claim Your 3-Week QuickStart Today and Join Us in Winning the Fight
            Against Pain...
          </h2>
          <ul className={styles.ultag2}>
            <li className={styles.list2}>
              100% botanical and fish oil research-based formula
            </li>
            <li className={styles.list2}>
              Support for relief against aches and pains
            </li>
            <li className={styles.list2}>
              {' '}
              Convenient individual packets that target the inflamed areas of
              your body
            </li>
          </ul>
          <h2 className={styles.header3}>
            Get Your QuickStart
            <br />
            Today for Just ${`${rfOfferPrice.initialPrice}`} + S&H
          </h2>
          <div style={{ textAlign: 'center' }}>
            <button onClick={handleSubmit} className={styles.button}>
              Order Now
            </button>
            <div className={styles.quickstartphone}>
              <span>To place your 3-Week QuickStart order by phone call</span>
              <div>
                <a href={`tel:+1-${ORDER_PHONENO}`}>
                  <span>{ORDER_PHONENO}</span>
                </a>
              </div>
              <span>(Monday-Friday, 5am - 6pm PST,</span>
              <span>Saturday-Sunday, 7am - 4pm, PST)</span>
            </div>
          </div>
        </div>
        <div className={styles.quickStartImage}>
          <Image
            alt="Relief Factor QuickStart"
            src={productImages[productsKeyConstants.RF_RELIEF_FACTOR_QS_NEC]}
            loading="eager"
            loader={imgLoader}
            width={320}
            objectFit="contain"
            height={292}
          />
        </div>
      </div>
      <Supplement open={open} handleOpenClose={handleOpenClose} />
    </div>
  );
}

export default TurmericPage;
